import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../utils/api';
import { guardarSesion } from '../utils/sesion';
import {
  IconMunicipio,
  IconPersona,
  IconContrasena,
  IconMostrarContrasena,
  IconOcultarContrasena,
  IconAdvertencia,
} from '../components/icons';
import '../styles/login.css';

function Login() {
  const navigate = useNavigate();
  const [municipioId, setMunicipioId] = useState('');
  const [usuario, setUsuario] = useState('');
  const [password, setPassword] = useState('');
  const [mostrarPassword, setMostrarPassword] = useState(false);
  const [error, setError] = useState('');
  const [enviando, setEnviando] = useState(false);

  async function manejarSubmit(evento) {
    evento.preventDefault();
    setError('');
    setEnviando(true);
    try {
      const { data } = await api.post('/auth/login', {
        municipio_id: municipioId.trim(),
        usuario: usuario.trim(),
        password,
      });
      guardarSesion(data);
      navigate('/caja', { replace: true });
    } catch (err) {
      setError(err.response?.data?.error || 'No se pudo iniciar sesión. Intentá de nuevo.');
    } finally {
      setEnviando(false);
    }
  }

  return (
    <div className="login-container">
      <div className="login-gradient" />
      <div className="login-card">
        <div className="login-logo">
          <img src="/logo-betech.svg" alt="Betech" className="logo-img" />
        </div>
        <h1 className="login-title">Caja</h1>
        <p className="login-subtitle">Ingresá con tu usuario para empezar a cobrar.</p>

        <form className="login-form" onSubmit={manejarSubmit}>
          <div className="form-group">
            <label htmlFor="municipio_id">Municipio</label>
            <div className="input-wrapper">
              <span className="input-icon">
                <IconMunicipio size={18} />
              </span>
              <input
                id="municipio_id"
                className="form-input"
                type="text"
                value={municipioId}
                onChange={(e) => setMunicipioId(e.target.value)}
                autoComplete="organization"
                required
              />
            </div>
          </div>

          <div className="form-group">
            <label htmlFor="usuario">Usuario</label>
            <div className="input-wrapper">
              <span className="input-icon">
                <IconPersona size={18} />
              </span>
              <input
                id="usuario"
                className="form-input"
                type="text"
                value={usuario}
                onChange={(e) => setUsuario(e.target.value)}
                autoComplete="username"
                required
              />
            </div>
          </div>

          <div className="form-group">
            <label htmlFor="password">Contraseña</label>
            <div className="input-wrapper input-wrapper-password">
              <span className="input-icon">
                <IconContrasena size={18} />
              </span>
              <input
                id="password"
                className="form-input"
                type={mostrarPassword ? 'text' : 'password'}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                autoComplete="current-password"
                required
              />
              <button
                type="button"
                className="btn-mostrar-contrasena"
                onClick={() => setMostrarPassword((v) => !v)}
                aria-label={mostrarPassword ? 'Ocultar contraseña' : 'Mostrar contraseña'}
              >
                {mostrarPassword ? <IconOcultarContrasena size={18} /> : <IconMostrarContrasena size={18} />}
              </button>
            </div>
          </div>

          {error && (
            <p className="mensaje-error">
              <IconAdvertencia size={16} />
              {error}
            </p>
          )}

          <button type="submit" className="boton boton-primario" disabled={enviando}>
            {enviando ? 'Ingresando…' : 'Ingresar'}
          </button>
        </form>
      </div>
    </div>
  );
}

export default Login;
